import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    const formData = new URLSearchParams();
    formData.append('email', email);
    try {
      await fetch('https://readdy.ai/api/form/d8ultl5u37m8lq7g36tg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
    } catch (_) {
      // ignore errors
    }
    setSubmitted(true);
    setEmail('');
  };

  return (
    <footer className="bg-foreground-900 text-background-50 rounded-t-3xl mx-4 md:mx-8 mt-16">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <h3 className="font-heading text-2xl md:text-3xl font-semibold mb-3">Fique por Dentro</h3>
            <p className="text-sm text-background-300 leading-relaxed mb-8">
              Receba as últimas atualizações do Hoobuy Spreadsheet diretamente no seu email.
            </p>
            {submitted ? (
              <p className="text-sm text-accent-400 font-medium">Obrigado por se inscrever!</p>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form="">
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="honeypot-field"
                />
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Seu melhor email"
                    required
                    className="flex-1 bg-transparent border-b border-background-500 py-2 text-sm text-background-50 placeholder:text-background-500 outline-none focus:border-background-200 transition-colors"
                  />
                  <button
                    type="submit"
                    className="px-6 py-2 bg-background-50 text-foreground-900 text-sm font-medium rounded-full hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
                  >
                    Inscrever <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </form>
            )}
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-5 text-background-100 uppercase tracking-wider">Categorias</h4>
            <div className="flex flex-col gap-3">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors underline decoration-background-700 underline-offset-4 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-5 text-background-100 uppercase tracking-wider">Guias</h4>
            <div className="flex flex-col gap-3">
              {articles.slice(0, 5).map((a) => (
                <Link
                  key={a.slug}
                  to={`/artigo/${a.slug}`}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors underline decoration-background-700 underline-offset-4 cursor-pointer whitespace-nowrap"
                >
                  {a.title.length > 45 ? a.title.slice(0, 45) + '...' : a.title}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-5 text-background-100 uppercase tracking-wider">Contato</h4>
            <div className="flex flex-col gap-3">
              <p className="text-sm text-background-400">contato@hoobuy.cam</p>
              <p className="text-sm text-background-400">
                Disponibilizamos o melhor spreadsheet de produtos da China, atualizado semanalmente.
              </p>
            </div>
            <div className="mt-8">
              <h4 className="text-sm font-semibold mb-3 text-background-100 uppercase tracking-wider">Siga-nos</h4>
              <div className="flex gap-4">
                <a href="#" className="text-background-400 hover:text-background-100 transition-colors cursor-pointer underline decoration-background-700 underline-offset-4 text-sm">Twitter</a>
                <a href="#" className="text-background-400 hover:text-background-100 transition-colors cursor-pointer underline decoration-background-700 underline-offset-4 text-sm">Instagram</a>
                <a href="#" className="text-background-400 hover:text-background-100 transition-colors cursor-pointer underline decoration-background-700 underline-offset-4 text-sm">TikTok</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800/50 px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex gap-5">
          <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer underline decoration-background-700 underline-offset-4">Twitter</a>
          <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer underline decoration-background-700 underline-offset-4">Instagram</a>
          <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer underline decoration-background-700 underline-offset-4">TikTok</a>
        </div>
        <p className="text-xs text-background-600 text-center">
          &copy; {new Date().getFullYear()} Hoobuy.cam — Todos os direitos reservados.
        </p>
        <div className="flex gap-5">
          <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer underline decoration-background-700 underline-offset-4">Privacidade</a>
          <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer underline decoration-background-700 underline-offset-4">Termos</a>
        </div>
      </div>
    </footer>
  );
}